<headerCustom></headerCustom>
<!--Functional Skill Rating Form Modal Box-->
<div
  *ngIf="showHideModel"
  class="modal fade adduserPopContainer"
  id="funSkillRatingPopContainer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="funSkillRatingPopContainer"
  aria-hidden="true"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form [formGroup]="functionalSkillRatingForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            TR Nominee Functional Competency Rating Form
          </h5>
          <button
            type="button"
            #closeModel2
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- <div class="ratingHeader">
          <span>Rating: ( 5: Strength, 4: Talented, 3: Skilled/Okay, 2: Weakness, 1: Clear Deficiency )</span>
        </div> -->
        <div class="modal-body">
          <div
            class="notice"
            *ngIf="
              fetchData[0] &&
              fetchData[0].isenabledFun == 'false' &&
              dateRanges.length <= 1
            "
          >
            You will not be able to fill the ratings yet. You can fill
            self-ratings after HR initiates the process for you.
          </div>

          <div
            class="row"
            *ngIf="fetchData[0] && fetchData[0].isenabledFun == 'true'"
          >
            <div class="col-sm-3"></div>

            <div class="col-sm-9">
              <div class="row">
                <div class="col-sm-7">
                  <label>Competency</label>
                </div>
                <div class="col-sm-1">
                  <label>Target</label>
                </div>
                <div class="col-sm-4">
                  <label>Actual</label>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            *ngIf="fetchData[0] && fetchData[0].isenabledFun == 'true'"
          >
            <label for="level" class="col-sm-3 col-form-label control-label"
              >Competency Levels</label
            >
            <div class="col-sm-9">
              <div class="row">
                <ng-container *ngFor="let skill of skillData; let i = index">
                  <ng-container>
                    <!-- *ngIf="skill.positionId === selectedPositionId" -->
                    <div class="col-sm-7" style="margin-bottom: 2px">
                      <label class="form-control">{{ skill.skillName }}</label>
                    </div>
                    <div class="col-sm-1" style="margin-bottom: 2px">
                      <label class="form-control">{{
                        skill.targetScore
                      }}</label>
                    </div>
                    <div class="col-sm-4">
                      <select
                        class="form-control form-control-lg"
                        placeholder="select competency level"
                        formControlName="{{ skill.skillName }}"
                        style="width: 135px"
                      >
                        <option value="">Select Rating</option>

                        <ng-container
                          *ngFor="
                            let skillRating of skillRatingData;
                            let i = index
                          "
                        >
                          <option
                            value="{{ skillRating.score }}"
                            [selected]="skillRating.score == '1'"
                          >
                            {{ skillRating.ratingName }}
                          </option>
                        </ng-container>
                      </select>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label for="skillRatingFromDate" class="col-sm-3 col-form-label control-label">Competencies Rating Start
              Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.skillRatingFromDate.errors }"
                  placeholder="yyyy-mm-dd" ngbDatepicker #d1="ngbDatepicker" formControlName="skillRatingFromDate"
                  class="form-control">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setStartDate(); d1.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="form-group row">
            <label for="skillRatingToDate" class="col-sm-3 col-form-label control-label">Competencies Rating End Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input class="form-control" type="text" autocomplete="off" placeholder="yyyy-mm-dd" ngbDatepicker
                  #d2="ngbDatepicker" formControlName="skillRatingToDate">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setEndDate(); d2.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div> -->

          <div
            class="row addUserButton mb-2"
            *ngIf="fetchData[0] && fetchData[0].isenabledFun == 'true'"
          >
            <div class="col-md-12">
              <button
                type="button"
                class="btn hvr-bounce-to-top"
                data-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>

              <button
                class="btn hvr-bounce-to-top mr10"
                (click)="onSubmit(functionalSkillRatingForm.value, true)"
                [disabled]="
                  functionalSkillRatingForm.invalid ||
                  (fetchData[0] && fetchData[0].isenabledFun) == 'false'
                "
              >
                Submit Rating
              </button>
            </div>
          </div>

          <div class="tableWrapper">
            <table
              class="table rTsCustomizeTable ratingsTable"
              *ngIf="dateRanges.length > 1"
            >
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Skill</th>

                  <th *ngFor="let dateRange of dateRanges; index as i">
                    <ng-container *ngIf="dateRange !== 1">
                      {{ dateRange == 1 ? "" : dateRange }}
                    </ng-container>
                  </th>
                </tr>
              </thead>
              <tbody class="text-center">
                <ng-container *ngFor="let row of convertedData; let i = index">
                  <tr>
                    <td>
                      <div>{{ i + 1 }}</div>
                    </td>
                    <ng-container *ngFor="let cell of row; let j = index">
                      <td>
                        <div>{{ cell }}</div>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!--Behavioral Skills Modal Box-->
<div
  *ngIf="showHideModel"
  class="modal fade adduserPopContainer"
  id="behavioralSkillPopContainer"
  tabindex="-1"
  role="dialog"
  aria-labelledby="behavioralSkillPopContainer"
  aria-hidden="true"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form [formGroup]="behavioralSkillRatingForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            TR Nominee Behavioral Competency Rating Form
          </h5>
          <button
            type="button"
            #closeModel1
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- <div class="ratingHeader">
          <span>Rating: ( 5: Strength, 4: Talented, 3: Skilled/Okay, 2: Weakness, 1: Clear Deficiency )</span>
        </div> -->
        <div class="modal-body">
          <div
            class="notice"
            *ngIf="
              fetchData[0] &&
              fetchData[0].isenabledBeh == 'false' &&
              dateRanges.length <= 1
            "
          >
            You will not be able to fill the ratings yet. You can fill
            self-ratings after HR initiates the process for you.
          </div>

          <div
            class="row"
            *ngIf="fetchData[0] && fetchData[0].isenabledBeh == 'true'"
          >
            <div class="col-sm-3"></div>

            <div class="col-sm-9">
              <div class="row">
                <div class="col-sm-7">
                  <label>Competency</label>
                </div>
                <div class="col-sm-1">
                  <label>Target</label>
                </div>
                <div class="col-sm-4">
                  <label>Actual</label>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            *ngIf="fetchData[0] && fetchData[0].isenabledBeh == 'true'"
          >
            <label for="level" class="col-sm-3 col-form-label control-label"
              >Competency Levels</label
            >
            <div class="col-sm-9">
              <div class="row">
                <ng-container *ngFor="let skill of behSkillList; let i = index">
                  <ng-container>
                    <!-- *ngIf="skill.positionId === selectedPositionId" -->
                    <div class="col-sm-7" style="margin-bottom: 2px">
                      <label class="form-control">{{ skill.skillName }}</label>
                    </div>
                    <div class="col-sm-1" style="margin-bottom: 2px">
                      <label class="form-control">{{
                        skill.targetScore
                      }}</label>
                    </div>
                    <div class="col-sm-4">
                      <select
                        class="form-control form-control-lg"
                        placeholder="Select competency level"
                        formControlName="{{ skill.skillName }}"
                        style="width: 135px"
                      >
                        <!-- <option value="">Select Rating</option> -->

                        <ng-container
                          *ngFor="
                            let skillRating of skillRatingData;
                            let i = index
                          "
                        >
                          <option
                            value="{{ skillRating.score }}"
                            [selected]="skillRating.score == '1'"
                          >
                            {{ skillRating.ratingName }}
                          </option>
                        </ng-container>
                      </select>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label for="skillRatingFromDate" class="col-sm-3 col-form-label control-label">Competencies Rating Start
              Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.skillRatingFromDate.errors }"
                  placeholder="yyyy-mm-dd" ngbDatepicker #d1="ngbDatepicker" formControlName="skillRatingFromDate"
                  class="form-control">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setStartDate(); d1.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="skillRatingToDate" class="col-sm-3 col-form-label control-label">Competencies Rating End Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input class="form-control" type="text" autocomplete="off" placeholder="yyyy-mm-dd" ngbDatepicker
                  #d2="ngbDatepicker" formControlName="skillRatingToDate">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setEndDate(); d2.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
         -->
          <div
            class="row addUserButton mb-2"
            *ngIf="fetchData[0] && fetchData[0].isenabledBeh == 'true'"
          >
            <div class="col-md-12">
              <button
                type="button"
                class="btn hvr-bounce-to-top"
                data-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                class="btn hvr-bounce-to-top mr10"
                (click)="onSubmit(behavioralSkillRatingForm.value, false)"
                [disabled]="
                  behavioralSkillRatingForm.invalid ||
                  (fetchData[0] && fetchData[0].isenabledBeh == 'FALSE')
                "
              >
                Submit Rating
              </button>
            </div>
          </div>

          <div class="tableWrapper">
            <table
              class="table rTsCustomizeTable ratingsTable"
              *ngIf="dateRanges.length > 1"
            >
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Skill</th>
                  <th *ngFor="let dateRange of dateRanges; index as i">
                    <ng-container *ngIf="dateRange !== 1">
                      {{ dateRange == 1 ? "" : dateRange }}
                    </ng-container>
                  </th>
                </tr>
              </thead>
              <tbody class="text-center">
                <ng-container *ngFor="let row of convertedData; let i = index">
                  <tr>
                    <td>
                      <div>{{ i + 1 }}</div>
                    </td>
                    <ng-container *ngFor="let cell of row; let j = index">
                      <td>
                        <div>{{ cell }}</div>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- <sidebarWrapper></sidebarWrapper> -->

<div class="main-content">
  <!-- Show users details in table -->
  <div class="adduserContainer">
    <div class="pageContentWrapper">
      <div class="pageHeading">
        <div class="row">
          <div class="col-12">
            <div class="headerName">
              <h3>My Details</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="fetchData.length == 0">
        <div
          class="addSkillRatingFormLayout customizeRtsScrollBar addSkillRatingFormContainer"
        >
          <table datatable class="table rTsCustomizeTable">
            <thead>
              <tr>
                <th>S.No.</th>
                <th width="10%">Emp Code</th>
                <th width="10%">Emp Name</th>
                <th>Supervisor</th>
                <th>Current Role</th>
                <th>Next Role</th>
                <th>Nomination Status</th>
                <!-- <th>Type of Resource</th> -->
                <th
                  *ngIf="isAppr == 0 ? false : isAppr == 1 ? true : false"
                  data-orderable="false"
                >
                  Functional Rating
                </th>
                <th
                  *ngIf="isAppr == 0 ? false : isAppr == 1 ? true : false"
                  data-orderable="false"
                >
                  Behavioral Rating
                </th>
                <th
                  *ngIf="isAppr == 0 ? true : isAppr == 1 ? false : false"
                  data-orderable="false"
                >
                  View
                </th>
              </tr>
            </thead>
            <tbody class="text-center"></tbody>
          </table>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="fetchData.length > 0">
        <div
          class="addSkillRatingFormLayout customizeRtsScrollBar addSkillRatingFormContainer"
        >
          <table datatable class="table rTsCustomizeTable">
            <thead>
              <tr>
                <th>S.No.</th>
                <th width="10%">Emp Code</th>
                <th width="10%">Emp Name</th>
                <th>Supervisor</th>
                <th>Current Role</th>
                <th>Next Role</th>
                <th>Nomination Status</th>
                <!-- <th>Type of Resource</th> -->
                <th
                  *ngIf="isAppr == 0 ? false : isAppr == 1 ? true : false"
                  data-orderable="false"
                >
                  Functional Rating
                </th>
                <th
                  *ngIf="isAppr == 0 ? false : isAppr == 1 ? true : false"
                  data-orderable="false"
                >
                  Behavioral Rating
                </th>
                <th
                  *ngIf="isAppr == 0 ? true : isAppr == 1 ? false : false"
                  data-orderable="false"
                >
                  View
                </th>
              </tr>
            </thead>
            <tbody class="text-center">
              <ng-container
                *ngFor="let fetchuserData of fetchData; let i = index"
              >
                <tr>
                  <td>
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchData.indexOf(fetchuserData) + 1 }}
                    </div>
                  </td>

                  <td class="addUserName">
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchuserData.empCode }}
                    </div>
                  </td>
                  <td class="addUserName">
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchuserData.userName }}
                    </div>
                  </td>
                  <td class="userSelectType">
                    <div ngClass="{{ fetchuserData.leaveUserCSS }}">
                      {{ fetchuserData.resourceManager }}
                    </div>
                  </td>
                  <!-- <td class="userSelectType">
                    <div ngClass="{{fetchuserData.leaveUserCSS}}">{{fetchuserData.typeResource}}</div>
                  </td> -->
                  <td>
                    <div>{{ fetchuserData.positionName }}</div>
                  </td>
                  <td>
                    <div>{{ getPositionName(fetchuserData.nextPosition) }}</div>
                  </td>
                  <td>
                    <!-- <div [ngStyle]="{'color':fetchuserData.isApproved==0?'red':fetchuserData.isApproved==1?'green':'black'}">{{fetchuserData.isApproved==0?'Rejected':fetchuserData.isApproved==1?'Approved':'Nomination Pending'}}</div> -->
                    <div
                      [ngStyle]="{
                        color:
                          fetchuserData.isApproved == 0
                            ? 'red'
                            : fetchuserData.isApproved == 1
                            ? 'green'
                            : 'black'
                      }"
                    >
                      {{
                        commonService.getUserStatus(fetchuserData.isApproved)
                      }}
                    </div>
                  </td>
                  <td
                    class="addUserButtons"
                    *ngIf="
                      fetchuserData.isApproved == 0
                        ? false
                        : fetchuserData.isApproved == 1
                        ? true
                        : false
                    "
                  >
                    <!-- <app-interested-users style="display: none;" (valueChange)="displayStatus($event)">
                    </app-interested-users> -->
                    <div>
                      <button
                        id="btnfncR"
                        class="btn form-group hvr-bounce-to-top"
                        title="Functional Competencies Rating"
                        data-toggle="modal"
                        data-target="#funSkillRatingPopContainer"
                        (click)="onEditSubmit(fetchuserData, true)"
                      >
                        <img
                          src="assets/funRating.png"
                          style="margin-left: 2px; width: 0.9rem"
                        />
                      </button>
                    </div>
                  </td>
                  <td
                    class="addUserButtons"
                    *ngIf="
                      fetchuserData.isApproved == 0
                        ? false
                        : fetchuserData.isApproved == 1
                        ? true
                        : false
                    "
                  >
                    <div>
                      <button
                        class="btn form-group hvr-bounce-to-top"
                        title="Behavioral Competencies Rating"
                        data-toggle="modal"
                        data-target="#behavioralSkillPopContainer"
                        (click)="onEditSubmit(fetchuserData, false)"
                      >
                        <!-- <img src="assets/rating.png" /> -->
                        <i class="fa fa-tasks"></i>
                      </button>
                    </div>
                  </td>
                  <td
                    class="addUserButtons"
                    *ngIf="
                      fetchuserData.isApproved == 0
                        ? true
                        : fetchuserData.isApproved == 1
                        ? false
                        : false
                    "
                  >
                    <div>
                      <button
                        class="btn form-group hvr-bounce-to-top"
                        title="View"
                        data-toggle="modal"
                        data-target="#viewApplicantDetails"
                      >
                        <!-- <img src="assets/rating.png" /> -->
                        <i class="fa fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="loader" *ngIf="loading">
  <div class="lds-roller">
    <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

<div
  *ngIf="isShowModel"
  class="modal fade"
  id="viewApplicantDetails"
  tabindex="-1"
  role="dialog"
  aria-labelledby="adduserPopContainer"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Applicant Detail Form</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <h4
                *ngIf="modelData.isApproved == 0 ? true : false"
                class="alert-msgto"
              >
                Your Request has been Rejected. <br />
                Please contact to your HR for more query!
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Employee Code</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.empCode }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Employee Name</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.userName }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Email Id</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.email }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6">
              <div class="form-group">
                <label for="empCodetest" class="col-form-label control-label"
                  >IBU</label
                >
                <div>
                  <select
                    class="form-control"
                    [(ngModel)]="ibu"
                    (change)="onChangeIBU()"
                  >
                    <option value="">Select IBU</option>
                    <ng-container *ngFor="let ibuItem of ibuList">
                      <option [ngValue]="ibuItem">{{ ibuItem.ibuName }}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Function</label
                >
                <div>
                  <select
                    class="form-control"
                    [(ngModel)]="function"
                    (change)="onChangeFunction()"
                  >
                    <option value="">Select Function</option>
                    <ng-container *ngFor="let functionItem of functionList">
                      <option [ngValue]="functionItem">
                        {{ functionItem.functionName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Tower</label
                >
                <div>
                  <select class="form-control" [(ngModel)]="tower">
                    <option value="">Select Tower</option>
                    <ng-container *ngFor="let towerItem of towerList">
                      <option [ngValue]="towerItem">
                        {{ towerItem.towerName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div> -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Current Role</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.positionName }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div
              class="col-md-6"
              [class]="modelData?.isNextTowerSame ? 'd-none' : ''"
            >
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Next IBU</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.nextPositionIbuName }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div
              class="col-md-6"
              [class]="modelData?.isNextTowerSame ? 'd-none' : ''"
            >
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Next Function</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.nextPositionFunctionName }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div
              class="col-md-6"
              [class]="modelData?.isNextTowerSame ? 'd-none' : ''"
            >
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Next Tower</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.nextPositionTowerName }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Next Role</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ getPositionName(modelData.nextPosition) }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Exp. in Current Role (in Months.)</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.experience }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Latest BSC Score (H1/H2)</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ modelData.lastBSC }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Why you want to move to next role?</label
                >
                <div>
                  <textarea
                    class="form-control"
                    rows="3"
                    cols="63"
                    placeholder=""
                    value="{{ modelData.whyMove }}"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>

            <div
              class="col-md-12"
              *ngIf="modelData.isApproved == 0 ? true : false"
            >
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Reason:</label
                >
                <div>
                  <textarea
                    class="form-control"
                    rows="3"
                    cols="63"
                    placeholder=""
                    value="{{ modelData.whyApprove }}"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
